module.exports = __webpack_public_path__ + "img/img_2.415ce0bb.png";